<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu :pageTitle="pageTitle" />

    <div class="card border-0 shadow-none rounded-1 mb-25">
      <div class="card-body p-xl-40">
        <div class="row g-3 align-items-center">
          <div class="col-lg-8">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <div class="search-box position-relative">
                <input
                  v-model="searchQuery"
                  type="text"
                  :placeholder="$t(`${i18nScope}.search_placeholder`)"
                  class="form-control bg-white h-55 shadow-none pe-5"
                />
                <span class="search-icon">
                  <i class="ri-search-line"></i>
                </span>
              </div>

              <select
                v-model="filters.warehouse_id"
                class="form-select report-select h-55 shadow-none"
              >
                <option :value="null">{{ $t(`${i18nScope}.all_warehouses`) }}</option>
                <option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">
                  {{ warehouse.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="d-flex justify-content-lg-end align-items-center gap-2 flex-wrap">
              <span class="summary-chip">
                {{ $t(`${i18nScope}.qty_value_summary`, {
                  qty: summary.totalQty,
                  value: formatReportAmount(summary.totalValue),
                }) }}
              </span>
              <button
                type="button"
                class="btn style-three d-inline-flex align-items-center h-55 px-4"
                :disabled="exporting"
                @click="exportStockReport"
              >
                <i class="ri-file-excel-2-line me-1"></i>
                {{ exporting ? $t(`${i18nScope}.exporting`) : $t(`${i18nScope}.excel`) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <StockReport
      :items="items"
      :loading="loading"
      :pagination="pagination"
      :selected-product-ids="selectedProductIds"
      :i18n-scope="i18nScope"
      @table-change="handleTableChange"
      @selection-change="updateSelectedProducts"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import StockReport from "../../components/Reports/StockReport/StockReport.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useStockReport } from "../../composables/useStockReport";

export default defineComponent({
  name: "StockReportPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    StockReport,
    MainFooter,
  },
  setup() {
    return useStockReport();
  },
});
</script>

<style scoped>
.search-box {
  width: min(100%, 400px);
}

.search-box .form-control {
  padding-left: 18px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #fff;
  color: #1f2940;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.search-box .form-control:focus,
.report-select:focus {
  border-color: #5d5fef;
  box-shadow: 0 0 0 3px rgba(93, 95, 239, 0.12);
}

.search-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #8f9bb3;
  pointer-events: none;
  font-size: 18px;
}

.report-select {
  min-width: 220px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #fff;
  color: #1f2940;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.summary-chip {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #5d5fef;
  background: rgba(93, 95, 239, 0.1);
}
</style>
